var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_456",
    "data-name": "Group 456",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 15,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M0,7.5A7.5,7.5,0,1,1,7.472,15,7.506,7.506,0,0,1,0,7.5M4.247,9.877a.848.848,0,0,0,.52.786.8.8,0,0,0,.92-.183q.824-.811,1.633-1.636c.122-.125.186-.145.32-.007.525.544,1.068,1.073,1.6,1.61a.841.841,0,0,0,.69.278.794.794,0,0,0,.724-.54.8.8,0,0,0-.2-.9q-.82-.83-1.651-1.648c-.11-.107-.117-.163,0-.274.547-.533,1.082-1.078,1.624-1.616a.847.847,0,0,0,.281-.708.839.839,0,0,0-1.432-.517q-.837.827-1.663,1.666c-.1.1-.157.1-.259,0-.52-.531-1.048-1.053-1.574-1.578A.848.848,0,1,0,4.585,5.79c.525.526,1.047,1.054,1.579,1.573.113.11.111.166,0,.274-.551.539-1.091,1.089-1.638,1.631a.908.908,0,0,0-.278.609",
    transform: "translate(0 0)",
    fill: "#e3293c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M108.4,114.547a.907.907,0,0,1,.277-.609c.547-.542,1.087-1.092,1.638-1.631.111-.109.113-.164,0-.274-.532-.519-1.054-1.047-1.579-1.573a.848.848,0,1,1,1.195-1.181c.526.525,1.054,1.047,1.574,1.578.1.1.156.105.259,0q.824-.84,1.663-1.666a.839.839,0,0,1,1.432.517.846.846,0,0,1-.281.708c-.542.538-1.077,1.083-1.624,1.616-.114.111-.107.167,0,.274q.833.816,1.651,1.648a.8.8,0,0,1,.2.9.794.794,0,0,1-.724.54.841.841,0,0,1-.69-.278c-.533-.537-1.075-1.065-1.6-1.61-.134-.139-.2-.118-.32.007q-.807.827-1.633,1.636a.8.8,0,0,1-.92.183.848.848,0,0,1-.52-.786",
    transform: "translate(-104.151 -104.669)",
    fill: "#fff2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M191.632,0V6.257a.326.326,0,0,0,.083-.066q.824-.84,1.663-1.666a.839.839,0,0,1,1.432.517.846.846,0,0,1-.281.708c-.542.538-1.077,1.083-1.624,1.616-.114.111-.107.167,0,.274q.833.816,1.651,1.648a.8.8,0,0,1,.2.9.794.794,0,0,1-.724.54.841.841,0,0,1-.69-.278c-.533-.537-1.075-1.065-1.6-1.61a.358.358,0,0,0-.111-.086V15a7.5,7.5,0,0,0,0-15",
    transform: "translate(-184.124 -0.004)",
    fill: "#b3212f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M194.558,113.954q-.82-.83-1.651-1.648c-.11-.107-.117-.163,0-.274.547-.533,1.082-1.078,1.624-1.616a.846.846,0,0,0,.281-.708.839.839,0,0,0-1.432-.517q-.837.827-1.663,1.666a.327.327,0,0,1-.083.066v2.5a.359.359,0,0,1,.111.086c.525.544,1.068,1.073,1.6,1.61a.84.84,0,0,0,.69.278.794.794,0,0,0,.724-.54.8.8,0,0,0-.2-.9",
    transform: "translate(-184.124 -104.669)",
    fill: "#d8e5eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCloseIcon);
export default __webpack_public_path__ + "static/media/red_close_icon.09290852795999899a31efb05a3b3a44.svg";
export { ForwardRef as ReactComponent };